/* CG UX (Oct 12 2026, R40). Loaded sitewide from snippets/card-description-clamp.liquid.
   Menu page: any dish with choices (sides, bread, temp, add ons) opens the dish sheet instead of
   quick-adding, and every pick-one choice (sides, temp, bread, egg style, dressing, soup, drink, flavor)
   has to be picked before Add to order. Add-ons, extras and ingredient changes stay optional.
   Burgers and sandwiches come with French Fries: that is the preselected side (it sends nothing, Toast's
   default), and the other sides are swaps. Clubs default to Garlic Cheese Sourdough. Salad dressing has a
   No Dressing choice, sent to the kitchen as a note because Toast has no No Dressing option. */
(function () {
  'use strict';
  var SIDE = /^(breakfast sides|waffles, pancakes and french toast sides|kids? side choice|kid's side choice|entree side|meat temp|bread choice|choice of toast|egg prep|egg style|brekafast meat choice|breakfast meat choice|salad dressing|soup choice|combo soup choice|combo salad choice|half sandwich option|sauce choice|tortilla chips or baguettes|pepperoni\/cheese|kids drink choice|soft drinks choice|juice choice|ice tea flavor|ice cream flavor|flavor ice cream|milk option)$/i;
  var FRIES = /^(burger & sandwich sides|sandwich sides)$/i, BREAD = /^sandwich bread$/i, DRESS = /^salad dressing$/i;
  var P = null;
  function products() {
    if (P) return P; P = {};
    var root = document.querySelector('[data-cgm][data-order-mode="native"]'); if (!root) return P;
    root.querySelectorAll('script[data-cgm-product]').forEach(function (s) { try { var p = JSON.parse(s.textContent); P[p.id] = p; } catch (e) {} });
    return P;
  }
  function groupName(gEl) {
    var t = gEl.querySelector('.cgc-opt__title'); if (!t) return '';
    var c = t.cloneNode(true); c.querySelectorAll('em,small,span').forEach(function (x) { x.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function sheetProduct(sheet) {
    var h = sheet.querySelector('.cgc-modal__body h3'), t = h ? h.textContent.trim() : '', all = products();
    for (var id in all) if (all[id].title === t) return all[id];
    return null;
  }
  function groupsBy(sheet, re) {
    var p = sheetProduct(sheet);
    return [].slice.call(sheet.querySelectorAll('.cgm-group')).filter(function (g) {
      var gi = +g.getAttribute('data-gi'), real = p && p.groups && p.groups[gi] ? p.groups[gi].name : '';
      return re.test(real) || re.test(groupName(g));
    });
  }
  function sideGroups(sheet) { return groupsBy(sheet, SIDE); }
  function addChoice(g, value, label, checked) {
    var box = g.querySelector('.cgc-choice'), any = box && box.querySelector('input'); if (!box || !any || box.querySelector('[data-cgux]')) return;
    /* R58: when the dish already offers this choice as a real Toast option (French Fries on the
       burger/sandwich side, now a Shopify option), don't add the note-only copy */
    if ([].some.call(box.querySelectorAll('input'), function (x) { return x.value === value; })) return;
    var l = document.createElement('label'), i = document.createElement('input');
    i.type = 'radio'; i.name = any.name; i.value = value; i.setAttribute('data-price', '0'); i.setAttribute('data-cgux', '1'); if (checked) i.checked = true;
    var s = document.createElement('span'); s.textContent = label;
    l.appendChild(i); l.appendChild(s); box.insertBefore(l, box.firstChild);
  }
  function defaults(sheet) {
    var p = sheetProduct(sheet), club = p && /club/i.test(p.title);
    groupsBy(sheet, FRIES).forEach(function (g) {
      var d = g.closest('details'); if (d && d.parentNode) d.parentNode.insertBefore(g, d);
      var none = !g.querySelector('input:checked'); addChoice(g, 'French Fries', 'French Fries (included)', none);
      var em = g.querySelector('.cgc-opt__title em'); if (em && em.textContent !== 'Fries included, or swap') em.textContent = 'Fries included, or swap';
    });
    if (club) groupsBy(sheet, BREAD).forEach(function (g) {
      if (g.__cgbread) return; g.__cgbread = true;
      var d = g.closest('details'); if (d && d.parentNode) d.parentNode.insertBefore(g, d);
      if (!g.querySelector('input:checked')) { var gs = g.querySelector('input[value="Garlic Cheese Sourdough"]'); if (gs) gs.checked = true; }
    });
    groupsBy(sheet, DRESS).forEach(function (g) { addChoice(g, 'No Dressing', 'No Dressing', false); });
  }

  /* 1. no quick add for dishes with choices: open the sheet so the guest sees sides and options */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cgm][data-order-mode="native"] button[data-cgm-add]'); if (!b) return;
    var p = products()[b.getAttribute('data-cgm-add')];
    if (!p || !p.groups || !p.groups.length || !window.CGMenu || !window.CGMenu.openSheet) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!p.available) return;
    window.CGMenu.openSheet(p);
    watch();
  }, true);

  /* R44 deep link: /pages/food-menu-new?dish=<handle> (from dish pages and the homepage carousel)
     scrolls to that dish and opens its choice sheet. Items with no choices just get scrolled to and highlighted. */
  (function () {
    var h; try { h = new URLSearchParams(location.search).get('dish'); } catch (e) {} if (!h) return;
    var tries = 0;
    (function go() {
      var all = products(), p = null;
      for (var k in all) { if (all[k] && all[k].handle === h) { p = all[k]; break; } }
      if (!p && tries++ < 40) { P = null; return setTimeout(go, 150); }
      if (!p) return;
      var b = document.querySelector('[data-cgm][data-order-mode="native"] button[data-cgm-add="' + p.id + '"]');
      var card = b && (b.closest('article,li,.cgm-card,.cgm-item') || b);
      if (card && card.scrollIntoView) { card.scrollIntoView({ block: 'center' }); card.style.outline = '2px solid #C42A0F'; setTimeout(function () { card.style.outline = ''; }, 2500); }
      if (!p.available || !p.groups || !p.groups.length) return;
      if (!window.CGMenu || !window.CGMenu.openSheet) { if (tries++ < 40) return setTimeout(go, 150); return; }
      window.CGMenu.openSheet(p); watch();
    })();
  })();

  /* 2. required choices sit up top (not inside "Add extras"), and each needs a pick */
  function liftSides(sheet) {
    defaults(sheet);
    sideGroups(sheet).forEach(function (g) {
      var d = g.closest('details'); if (d && d.parentNode) d.parentNode.insertBefore(g, d);
      var em = g.querySelector('.cgc-opt__title em'); if (em && !/required/i.test(em.textContent)) em.textContent = 'Required';
    });
    sheet.querySelectorAll('details.cgm-extras:not(.cgm-notes)').forEach(function (d) {
      var n = d.querySelector('.cgm-extras__n'); var k = d.querySelectorAll('.cgm-group').length;
      var want = k + ' group' + (k > 1 ? 's' : ''); if (n && k && n.textContent !== want) n.textContent = want;
      if (!k && d.style.display !== 'none') d.style.display = 'none';
    });
  }
  function watch() {
    var sheet = document.querySelector('.cgm-sheet'); if (!sheet) return false;
    if (sheet.__cgux) return true; sheet.__cgux = true;
    new MutationObserver(function () { liftSides(sheet); }).observe(sheet, { childList: true, subtree: true });
    liftSides(sheet);
    return true;
  }
  document.addEventListener('click', function () { setTimeout(watch, 0); }, true);
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cgm-sheet [data-submit]'); if (!btn) return;
    var sheet = btn.closest('.cgm-sheet'), miss = null;
    sideGroups(sheet).forEach(function (g) {
      var err = g.querySelector('.cgm-group__err');
      if (!g.querySelector('input:checked')) { if (err) { err.hidden = false; err.textContent = 'Pick one to continue'; } if (!miss) miss = g; }
      else if (err && err.textContent === 'Pick one to continue') err.hidden = true;
    });
    if (!miss) {
      /* fries are the default side and No Dressing is a note: neither is a Toast modifier, so don't send them */
      [].slice.call(sheet.querySelectorAll('input[data-cgux]:checked')).forEach(function (i) {
        i.checked = false;
        var t = sheet.querySelector('[data-notes]');
        if (i.value === 'No Dressing') { if (t && !/no dressing/i.test(t.value)) t.value = (t.value ? t.value + '. ' : '') + 'No dressing'; }
        /* Oct 14 2026: Toast's burger/sandwich side group has no French Fries option, so the included fries go to the kitchen as a note */
        if (i.value === 'French Fries') { if (t && !/side: french fries/i.test(t.value)) t.value = 'Side: French Fries' + (t.value ? '. ' + t.value : ''); }
      });
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    var d = miss.closest('details'); if (d) d.open = true;
    miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
})();

/* Catering side cart (Oct 13 2026): tapping anywhere outside the drawer closes it, not just the X.
   Add buttons are left alone so guests can keep adding while it is open. */
(function () {
  document.addEventListener('click', function (e) {
    var d = document.querySelector('.cgc-drawer.is-open'); if (!d) return;
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.cgc-drawer__panel') || t.closest('[data-cgc-add],button[data-cgm-add],.cgc-add,.cgc-modal,.cgc-bar')) return;
    var x = d.querySelector('.cgc-drawer__close'); if (x) x.click();
  }, true);
})();
